import { combineReducers } from "redux";
import { Gateway } from "../../types";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { FETCH_PAYMENT_GATEWAY_REQUEST } from "./constants";
import { Action } from "./types";

function item(state: Partial<Gateway> = {}, action: Action): Partial<Gateway> {
  switch (action.type) {
    case getSuccessActionType(FETCH_PAYMENT_GATEWAY_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_PAYMENT_GATEWAY_REQUEST:
      return true;

    case getSuccessActionType(FETCH_PAYMENT_GATEWAY_REQUEST):
    case getFailureActionType(FETCH_PAYMENT_GATEWAY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const paymentGateway = combineReducers({ item, isFetching });
